<template>
  <tw-panel>
    <tw-row :gutter="true">
      <tw-col :lg_span="8" :xl_span="9" :md_span="12" style="margin-bottom:0px;margin-left:0px;margin-right:0px;margin-top:0px">
        <tw-image src="./assets/logo.png" alt="" fit="fill" :preview="false" width="260px">
        </tw-image>
        <tw-panel style="display:inline-block;padding-left:10px">
          <tw-label text="东莞添慧软件有限公司" style="font-size:2.1rem;font-weight:600;display:table;line-height:63px">
          </tw-label>
        </tw-panel>
      </tw-col>
      <tw-col :md_span="12" style="margin-bottom:15px;margin-left:0px;margin-right:0px;margin-top:15px;text-align:right">
        <tw-panel style="display:inline-block">
          <tw-label text="广东省高新技术企业" style="font-size:14px;font-weight:600">
          </tw-label>
          <tw-panel>
            <tw-icon icon="pi pi-phone" style="display:inline-block;font-size:14px">
            </tw-icon>
            <tw-label text="400-6850858" style="display:inline-block;font-size:16px;font-weight:600;margin-left:5px">
            </tw-label>
          </tw-panel>
        </tw-panel>
        <tw-button text="数据中心" size="" @click="click_3f287d29_ed18" style="display:inline-block;height:30px;margin-left:15px">
        </tw-button>
        <tw-button text="预约演示" size="" @click="applyForTrial" style="display:inline-block;height:30px">
        </tw-button>
      </tw-col>
    </tw-row>
  </tw-panel>
  <tw-image src="./assets/image01.jpg" alt="" fit="fill" :preview="false" width="100%">
  </tw-image>
  <tw-panel style="position:relative">
    <tw-image src="./assets/image02.jpg" alt="" fit="fill" :preview="false" width="100%">
    </tw-image>
    <tw-button text="预约演示" @click="applyForTrial" style="position:absolute;left:50%;bottom:16px;margin-left:-35px">
    </tw-button>
  </tw-panel>
  <tw-panel style="position:relative">
    <tw-image src="./assets/image03.jpg" alt="" fit="fill" :preview="false" width="100%">
    </tw-image>
    <tw-button text="预约演示" @click="applyForTrial" style="position:absolute;left:50%;bottom:16px;margin-left:-35px">
    </tw-button>
  </tw-panel>
  <tw-panel style="position:relative">
    <tw-image src="./assets/image04.jpg" alt="" fit="fill" :preview="false" width="100%">
    </tw-image>
    <tw-button text="预约演示" @click="applyForTrial" style="position:absolute;left:50%;bottom:16px;margin-left:-35px">
    </tw-button>
  </tw-panel>
  <tw-image src="./assets/image05.jpg" alt="" fit="fill" :preview="false" width="100%">
  </tw-image>
  <tw-image src="./assets/image06.jpg" alt="" fit="fill" :preview="false" width="100%">
  </tw-image>
  <tw-panel style="padding-top:50px;padding-bottom:50px;text-align:center">
    <tw-row :gutter="true">
      <tw-col :md_span="4" :xl_span="4" style="margin-bottom:0px;margin-left:0px;margin-right:0px;margin-top:0px">
        <tw-panel style="font-size:20px;padding-top:10px;padding-bottom:10px">
          <tw-label text="联系我们">
          </tw-label>
          <tw-label text="销售热线：13926898719" style="display:block;margin-left:10px;font-size:18px">
          </tw-label>
          <tw-label text="邮箱：ys@tinwaysoft.com" style="display:block;margin-left:50px;font-size:18px">
          </tw-label>
          <tw-label text="400电话：400-6850858" style="display:block;margin-left:15px;font-size:18px">
          </tw-label>
          <tw-label text="地址：东莞市大朗镇新园一路6号B412" style="font-size:18px">
          </tw-label>
        </tw-panel>
      </tw-col>
      <tw-col :md_span="5" :xl_span="4" style="margin-bottom:0px;margin-left:0px;margin-right:0px;margin-top:0px">
        <tw-panel style="font-size:20px;padding-top:10px;padding-bottom:10px">
          <tw-label text="解决方案">
          </tw-label>
          <tw-label text="添慧服装行业ERP管理系统  毛衫行业版" style="display:block;font-size:18px">
          </tw-label>
          <tw-label text="添慧服装行业ERP管理系统 制衣行业版" style="display:block;font-size:18px">
          </tw-label>
          <tw-label text="添慧服装行业ERP管理系统 单件定制版" style="display:block;font-size:18px">
          </tw-label>
        </tw-panel>
      </tw-col>
      <tw-col :md_span="3" :xl_span="4" style="margin-bottom:0px;margin-left:0px;margin-right:0px;margin-top:0px">
        <tw-panel style="padding-top:10px;padding-bottom:10px">
          <tw-image src="./assets/weixin.jpg" alt="" fit="fill" :preview="false">
          </tw-image>
        </tw-panel>
      </tw-col>
    </tw-row>
  </tw-panel>
  <tw-panel style="text-align:center;padding-top:10px;padding-bottom:10px">
    <tw-label text="Copyright ©2020 添慧软件有限公司 版权所有 | ">
    </tw-label>
    <tw-link :underline="false" :disabled="false" icon="" href="https://beian.miit.gov.cn" modelValue="粤ICP备17105092号" :target="true">
    </tw-link>
  </tw-panel>
</template>

<script>
import { onMounted, toRefs } from 'vue'
import { useRoute } from 'vue-router'
import home_controller from './home.controller'

export default {
    setup(props, context) {
        const route = useRoute()
        const controller = new home_controller(props, context, route)

        onMounted(() => {
            try {
                if (controller.onMounted) {
                    controller.onMounted()
                }
            } catch (error) {
                console.log(error)
            }
        })

        const result = {
            applyForTrial: (...args) => { controller.applyForTrial(...args) },
            click_3f287d29_ed18: (...args) => { controller.click_3f287d29_ed18(...args) }
        }

        return {
            ...toRefs(result)
        }
    }
}
</script>